module.exports = __webpack_public_path__ + "img/crucero.74bd0bf7.png";